<div>
  {{ msg }}
</div>
